// extracted by mini-css-extract-plugin
export default {"titleSection":"styles_titleSection__j9yoj"};